export const translations = {
    en: {
        nav: {
            home: "Home",
            services: "Services",
            work: "Work",
            campaigns: "Campaigns",
            about: "About",
            contact: "Contact",
            cta: "Start a project",
            toggleMenu: "Toggle menu",
            light: "Switch to light mode",
            dark: "Switch to dark mode",
        },
        marquee: [
            "HMIS & HOSPITAL PORTALS",
            "TELEMEDICINE PLATFORMS",
            "SCHOOL & UNIVERSITY PORTALS",
            "E-LEARNING SYSTEMS",
            "STARTUP MVP LAUNCHPADS",
            "ELECTION CAMPAIGN PLATFORMS",
            "NAIROBI",
            "KAMPALA",
            "DAR ES SALAAM",
            "KIGALI",
            "WORLDWIDE",
        ],
        home: {
            eyebrow: "Digital infrastructure studio — East Africa → Worldwide",
            h1a: "We engineer the",
            h1b: "digital heartbeat",
            h1c: "of modern care.",
            sub: "Hallomedics builds websites, portals and apps for health systems across East Africa and worldwide — and for the schools, startups and campaigns that move a society forward.",
            ctaPrimary: "Start a project",
            ctaSecondary: "See our work",
            footnote: "HMIS · Telemedicine · E-learning · MVPs · Election platforms",
            systemsLive: "Systems live",
            uptime: "99.98% uptime",
            hq: "Nairobi HQ",
            healthEyebrow: "Primary practice — 01",
            healthH2: "Health systems, engineered with clinical precision.",
            healthCopy: "From county referral networks to private clinic chains — we build the calm, reliable software layer that care runs on.",
            flagshipTag: "Flagship build",
            flagshipTitle: "County referral network — patient portal & HMIS",
            b1t: "Hospital & HMIS portals",
            b1c: "Patient records, appointments, billing and bed management in one calm interface.",
            statValue: "40+",
            statLabel: "health facilities onboarded onto Hallomedics-built platforms",
            b2t: "Telemedicine & triage",
            b2c: "Remote consults that reach patients beyond the tarmac road.",
            imgCaption: "Diagnostics, connected",
            b3t: "E-pharmacy & supply",
            b3c: "Stock, ordering and cold-chain visibility for pharmacies and stores.",
            secondaryEyebrow: "Secondary practices — 02 · 03 · 04",
            secondaryH2: "Beyond the ward, the same standard of care.",
            practices: [
                {
                    tag: "Practice 02",
                    title: "Schools & Universities",
                    copy: "Websites, admissions funnels, parent & student portals and e-learning platforms for institutions shaping the next generation.",
                },
                {
                    tag: "Practice 03",
                    title: "Startup Ventures",
                    copy: "Marketing sites and MVP web apps that take new businesses from idea to first customers — fast, measured, investor-ready.",
                },
                {
                    tag: "Practice 04",
                    title: "Political Campaigns",
                    copy: "Manifesto sites, donation funnels and volunteer platforms for candidates — from county assemblies to governor, and President if needed.",
                },
            ],
            stats: ["health facilities digitized", "platforms launched", "countries served", "counties reached"],
            testiEyebrow: "Word from the field",
            testimonials: [
                {
                    quote: "“Our patient portal went from a PDF nobody read to a system 38 facilities rely on every morning. Hallomedics thinks like clinicians.”",
                    name: "Dr. A. Odhiambo",
                    role: "Medical Director, county referral network",
                },
                {
                    quote: "“Admissions season used to mean queues at the gate. Now parents apply from their phones — and our office finally sleeps.”",
                    name: "Mrs. R. Nakato",
                    role: "Registrar, private university",
                },
            ],
            ctaTag: "Next intake open",
            ctaH2: "Let's build the system your people deserve.",
            ctaCopy: "Tell us about your hospital, school, venture or campaign. We reply within one working day — with a plan, not a pitch deck.",
            ctaButton: "Book a discovery call",
        },
        services: {
            eyebrow: "What we build",
            h1a: "Four practices.",
            h1b: "One standard of care.",
            intro: "Every engagement — a county hospital or a presidential bid — gets the same discipline: discovery first, measured delivery, and support after launch.",
            enquirePrefix: "Enquire about",
            processEyebrow: "How we work",
            process: ["Discover", "Design", "Build", "Launch", "Support"],
            cta: "Start a project",
            browseWork: "Or browse our work first →",
            practices: [
                {
                    id: "health",
                    num: "01",
                    flag: "Primary practice",
                    title: "Health Systems",
                    lead: "Digital infrastructure for hospitals, clinic networks, county health departments and NGOs — in East Africa and worldwide.",
                    deliverables: ["Hospital & HMIS portals", "Telemedicine apps", "Patient booking & records", "E-pharmacy & inventory", "Health-data dashboards", "M-Pesa & insurance billing"],
                    serviceKey: "health-system",
                },
                {
                    id: "institutions",
                    num: "02",
                    flag: "Institutions",
                    title: "Schools & Universities",
                    lead: "Websites and platforms for schools, colleges and universities — from admissions to alumni.",
                    deliverables: ["School & university websites", "Admissions funnels", "Student & parent portals", "E-learning platforms", "Fee & exam tracking", "Alumni networks"],
                    serviceKey: "institution",
                },
                {
                    id: "startups",
                    num: "03",
                    flag: "New ventures",
                    title: "Startup Launchpads",
                    lead: "For founders starting up: a brand, a marketing site and a working product — sequenced so you launch lean and learn fast.",
                    deliverables: ["Brand & landing pages", "MVP web apps", "Booking & commerce flows", "Analytics & SEO setup", "Investor demo assets", "Iteration sprints"],
                    serviceKey: "startup",
                },
                {
                    id: "campaigns",
                    num: "04",
                    flag: "Civic & political",
                    title: "Campaign Platforms",
                    lead: "Digital ground-game for candidates — MCA to governor, and President if needed. Persuasive, fast, and built to withstand election-day traffic.",
                    deliverables: ["Manifesto websites", "Donation & merch funnels", "Volunteer CRM", "Constituency mapping", "SMS & WhatsApp integration", "Rapid-response war room support"],
                    serviceKey: "political-campaign",
                },
            ],
        },
        portfolio: {
            eyebrow: "Selected work",
            h1: "Proof, not promises.",
            intro: "A representative showcase of platforms we have shipped across health, education, ventures and civic campaigns. Client names abbreviated where discretion applies.",
            filters: [
                { key: "all", label: "All work" },
                { key: "health", label: "Health systems" },
                { key: "institution", label: "Schools & universities" },
                { key: "startup", label: "Startups" },
                { key: "campaign", label: "Campaigns" },
            ],
            categoryLabels: { health: "Health system", institution: "Education", startup: "Startup", campaign: "Campaign" },
            ctaH2: "Your project could be next.",
            ctaCopy: "Health system, school, startup or campaign — we would love to hear about it.",
            ctaButton: "Start a project",
        },
        about: {
            eyebrow: "The studio",
            h1a: "Built where the need",
            h1b: "is greatest.",
            p1: "Hallomedics began with a simple observation: the institutions that hold a society together — its hospitals, its schools, its new businesses, its elections — are served by the worst software.",
            p2: "We started in Nairobi building websites for health systems across East Africa. Today we ship worldwide, but the mission is unchanged: calm, dependable digital infrastructure for the people everyone else depends on.",
            p3: "Along the way we added three more practices — school and university platforms, launchpads for new ventures, and campaign machinery for candidates from governor to president — because the same discipline travels well.",
            imgChip: "Kampala · e-learning rollout",
            valuesEyebrow: "Operating principles",
            valuesH2: "How we decide, when it matters.",
            values: [
                { title: "Clinical precision", copy: "We scope like surgeons: diagnose first, cut once. No bloated features, no guesswork launches." },
                { title: "Local first, global standard", copy: "Built for East African realities — intermittent bandwidth, mobile money, county workflows — at a world-class engineering bar." },
                { title: "Radical reliability", copy: "Systems that stay up on admission day and election night. We monitor, patch and answer the phone." },
                { title: "Discretion & trust", copy: "Patient data and political strategy alike are handled with strict confidentiality and clear data stewardship." },
            ],
            teamEyebrow: "Leadership",
            teamH2: "A small team, deliberately.",
            teamRoles: ["Strategy & Health Systems", "Engineering Lead", "Design & Editorial", "Delivery & Support"],
            cta: "Work with us",
        },
        contact: {
            eyebrow: "Start a project",
            h1a: "Tell us what",
            h1b: "must work.",
            name: "Full name *",
            namePh: "Dr. Jane Wanjiru",
            email: "Email *",
            emailPh: "jane@hospital.or.ke",
            org: "Organization",
            orgPh: "Hospital, school, company or campaign",
            service: "What do you need? *",
            servicePh: "Choose a service",
            message: "Your project *",
            messagePh: "What are you building, who is it for, and when does it need to be live?",
            submit: "Send enquiry",
            sending: "Sending…",
            successToast: "Enquiry received — we reply within 24 hours.",
            errorToast: "Could not send your enquiry. Please try again.",
            nextEyebrow: "What happens next",
            steps: [
                { title: "We reply within 24 hours", copy: "A real person from our Nairobi studio — with questions, not a sales script." },
                { title: "A 30-minute discovery call", copy: "We map your goals, constraints and timeline. Free, no obligation." },
                { title: "A scoped plan in one week", copy: "Fixed scope, honest pricing, clear milestones. Then we build." },
            ],
            office: "Westlands, Nairobi — serving East Africa & worldwide",
            hours: "Mon–Fri, 08:00–18:00 EAT",
        },
        serviceLabels: {
            "health-system": "Health system",
            institution: "School / university",
            startup: "Startup / new business",
            "political-campaign": "Political campaign",
            other: "Something else",
        },
        campaigns: {
            eyebrow: "Practice 04 — Civic & political",
            h1a: "Win the digital",
            h1b: "ground game.",
            sub: "Manifesto sites, donation funnels and volunteer machinery for candidates — from MCA to governor, and President if needed. Engineered in Nairobi, battle-tested on campaign trails across East Africa.",
            ctaPrimary: "Plan my campaign",
            ctaSecondary: "See campaign work",
            imgChip: "Sauti Yetu 2027 — flagship campaign build",
            stats: ["volunteers registered", "constituencies covered", "raised online"],
            funnelEyebrow: "Donation funnels",
            funnelH2: "M-Pesa-native giving, in action.",
            funnelCopy: "Supporters give in three taps — no cards, no friction. Every shilling is receipted, auditable and ready for your compliance report. Try the live demo.",
            step1: "Choose an amount",
            stepContinue: "Continue",
            step2Title: "Check your phone",
            step2Copy: "Enter your M-Pesa PIN on the prompt we just sent to 07•• ••• •42.",
            step3Title: "Asante sana!",
            step3Copy: "donation confirmed. Every shilling is receipted and auditable.",
            receipt: "Receipt",
            donateAgain: "Run the demo again",
            demoNote: "Interactive demo — no real payment is processed.",
            volEyebrow: "Volunteer tools",
            volH2: "A field operation in every pocket.",
            volCopy: "Signup, vetting and deployment — with constituency mapping and SMS/WhatsApp mobilisation built in. See how a supporter joins:",
            volNamePh: "Your name",
            volWardPh: "Your ward / constituency",
            volButton: "Join the movement",
            volSuccess: "Karibu kwenye timu!",
            volSuccessCopy: "You are volunteer",
            volNote: "Demo — nothing is saved.",
            tools: [
                { title: "Signup & vetting", copy: "Structured intake forms with ward-level vetting workflows." },
                { title: "Constituency mapping", copy: "Live map of volunteers, agents and polling-station coverage." },
                { title: "SMS & WhatsApp blasts", copy: "Segmented mobilisation messages that actually get read." },
                { title: "Field reporting", copy: "Agents file reports from the ground in real time." },
            ],
            featuresEyebrow: "Built for the trail",
            featuresH2: "Serious machinery for serious races.",
            features: [
                { title: "Manifesto website", copy: "Your platform, beautifully told — and fast on the cheapest Android." },
                { title: "War-room dashboard", copy: "Donations, volunteers and sentiment, live in one view." },
                { title: "Election-day scale", copy: "Infrastructure that holds when the whole country is watching." },
                { title: "Discretion & security", copy: "Strategy stays sealed. Access is role-based and audited." },
            ],
            trustNote: "We work across the political spectrum. Client identities and strategy stay confidential — figures shown are from representative demo campaigns.",
            ctaH2: "Launch your campaign's digital headquarters.",
            ctaCopy: "One conversation is all it takes to know what your race needs.",
            ctaButton: "Plan my campaign",
        },
        footer: {
            blurb: "Digital infrastructure for health systems, schools & universities, new ventures and civic campaigns — built in East Africa, deployed worldwide.",
            cities: "Nairobi · Kampala · Dar es Salaam · Kigali",
            practice: "Practice",
            studio: "Studio",
            contactTitle: "Contact",
            links: {
                health: "Health systems",
                institutions: "Schools & universities",
                startups: "Startup ventures",
                campaigns: "Political campaigns",
                about: "About",
                work: "Work",
                contact: "Contact",
                admin: "Admin inbox",
            },
            hours: "Mon–Fri, 08:00–18:00 EAT",
            rights: "All rights reserved.",
            motto: "Care. Code. Country.",
        },
    },
    sw: {
        nav: {
            home: "Nyumbani",
            services: "Huduma",
            work: "Kazi Zetu",
            campaigns: "Kampeni",
            about: "Kuhusu Sisi",
            contact: "Wasiliana Nasi",
            cta: "Anza Mradi",
            toggleMenu: "Fungua menyu",
            light: "Badilisha hadi mwanga",
            dark: "Badilisha hadi giza",
        },
        marquee: [
            "MILANGO YA HOSPITALI & HMIS",
            "MAJUKWAA YA TELEMEDISINI",
            "MILANGO YA SHULE NA VYUO VIKUU",
            "MIFUMO YA E-ELIMU",
            "MVP ZA BIASHARA MPYA",
            "MAJUKWAA YA KAMPENI ZA UCHAGUZI",
            "NAIROBI",
            "KAMPALA",
            "DAR ES SALAAM",
            "KIGALI",
            "ULIMWENGUNI KOTE",
        ],
        home: {
            eyebrow: "Studio ya miundombinu ya kidijitali — Afrika Mashariki → Ulimwenguni",
            h1a: "Tunajenga",
            h1b: "mapigo ya kidijitali",
            h1c: "ya afya ya kisasa.",
            sub: "Hallomedics inajenga tovuti, milango na programu kwa mifumo ya afya barani Afrika Mashariki na ulimwenguni kote — pamoja na shule, biashara mpya na kampeni zinazosukuma jamii mbele.",
            ctaPrimary: "Anza mradi",
            ctaSecondary: "Tazama kazi zetu",
            footnote: "HMIS · Telemedisini · E-elimu · MVP · Mifumo ya uchaguzi",
            systemsLive: "Mifumo hai",
            uptime: "99.98% inapatikana",
            hq: "Makao Makuu Nairobi",
            healthEyebrow: "Huduma kuu — 01",
            healthH2: "Mifumo ya afya, iliyojengwa kwa usahihi wa kliniki.",
            healthCopy: "Kutoka mitandao ya rufaa ya kaunti hadi minyororo ya kliniki binafsi — tunajenga safu ya programu tulivu na ya kuaminika inayowezesha huduma za afya.",
            flagshipTag: "Mradi maarufu",
            flagshipTitle: "Mtandao wa rufaa wa kaunti — mlango wa wagonjwa & HMIS",
            b1t: "Milango ya hospitali & HMIS",
            b1c: "Kumbukumbu za wagonjwa, miadi, malipo na usimamizi wa vitanda katika kiolesura kimoja tulivu.",
            statValue: "40+",
            statLabel: "vituo vya afya vimejiunga na mifumo iliyojengwa na Hallomedics",
            b2t: "Telemedisini na upimaji",
            b2c: "Ushauri wa mbali unaofikia wagonjwa hata mbali na barabara kuu.",
            imgCaption: "Uchunguzi, umeunganishwa",
            b3t: "E-farmasi na ugavi",
            b3c: "Hisaa, oda na ufuatiliaji wa mnyororo wa baridi kwa maduka ya dawa na maghala.",
            secondaryEyebrow: "Huduma za ziada — 02 · 03 · 04",
            secondaryH2: "Ng'ambo ya wodi, kiwango kilekile cha ubora.",
            practices: [
                {
                    tag: "Huduma 02",
                    title: "Shule na Vyuo Vikuu",
                    copy: "Tovuti, mifereji ya udahili, milango ya wazazi na wanafunzi, na majukwaa ya e-elimu kwa taasisi zinazoandaa kizazi kijacho.",
                },
                {
                    tag: "Huduma 03",
                    title: "Biashara Mpya",
                    copy: "Tovuti za masoko na programu za MVP zinazochukua biashara mpya kutoka wazo hadi wateja wa kwanza — haraka, kwa kupimwa, tayari kwa wawekezaji.",
                },
                {
                    tag: "Huduma 04",
                    title: "Kampeni za Kisiasa",
                    copy: "Tovuti za ilani, mifereji ya michango na majukwaa ya wajitoleaji kwa wagombea — kutoka mabaraza ya kaunti hadi gavana, na Rais inapohitajika.",
                },
            ],
            stats: ["vituo vya afya vilivyodijitali", "majukwaa yaliyozinduliwa", "nchi zinazohudumiwa", "kaunti zilizofikiwa"],
            testiEyebrow: "Sauti kutoka kazini",
            testimonials: [
                {
                    quote: "“Mlango wetu wa wagonjwa uligeuka kutoka PDF ambayo hakuna aliyesoma hadi mfumo ambao vituo 38 vinautegemea kila asubuhi. Hallomedics hufikiri kama wataalamu wa afya.”",
                    name: "Dkt. A. Odhiambo",
                    role: "Mkurugenzi wa Matibabu, mtandao wa rufaa wa kaunti",
                },
                {
                    quote: "“Kipindi cha udahili kilimaanisha foleni mlangoni. Sasa wazazi hujiandikisha kwa simu zao — na ofisi yetu hatimaye inapumzika.”",
                    name: "Bi. R. Nakato",
                    role: "Msajili, chuo kikuu binafsi",
                },
            ],
            ctaTag: "Nafasi zimefunguliwa",
            ctaH2: "Hebu tujenge mfumo unaostahiliwa na watu wako.",
            ctaCopy: "Tuambie kuhusu hospitali, shule, biashara au kampeni yako. Tunajibu ndani ya siku moja ya kazi — kwa mpango, si hotuba ya mauzo.",
            ctaButton: "Weka miadi ya mazungumzo",
        },
        services: {
            eyebrow: "Tunachojenga",
            h1a: "Huduma nne.",
            h1b: "Kiwango kimoja cha ubora.",
            intro: "Kila mradi — iwe hospitali ya kaunti au kampeni ya urais — hupata nidhamu iyoiyo: uchunguzi kwanza, utekelezaji wenye kupimwa, na msaada baada ya uzinduzi.",
            enquirePrefix: "Uliza kuhusu",
            processEyebrow: "Jinsi tunavyofanya kazi",
            process: ["Gundua", "Buni", "Jenga", "Zindua", "Saidia"],
            cta: "Anza mradi",
            browseWork: "Au tazama kazi zetu kwanza →",
            practices: [
                {
                    id: "health",
                    num: "01",
                    flag: "Huduma kuu",
                    title: "Mifumo ya Afya",
                    lead: "Miundombinu ya kidijitali kwa hospitali, mitandao ya kliniki, idara za afya za kaunti na mashirika yasiyo ya kiserikali — Afrika Mashariki na ulimwenguni kote.",
                    deliverables: ["Milango ya hospitali & HMIS", "Programu za telemedisini", "Miadi na kumbukumbu za wagonjwa", "E-farmasi na hisaa", "Dashibodi za data ya afya", "Malipo ya M-Pesa na bima"],
                    serviceKey: "health-system",
                },
                {
                    id: "institutions",
                    num: "02",
                    flag: "Taasisi",
                    title: "Shule na Vyuo Vikuu",
                    lead: "Tovuti na majukwaa kwa shule, vyuo na vyuo vikuu — kutoka udahili hadi wanazuoni.",
                    deliverables: ["Tovuti za shule na vyuo vikuu", "Mifereji ya udahili", "Milango ya wanafunzi na wazazi", "Majukwaa ya e-elimu", "Ufuatiliaji wa ada na mitihani", "Mitandao ya wanazuoni"],
                    serviceKey: "institution",
                },
                {
                    id: "startups",
                    num: "03",
                    flag: "Biashara mpya",
                    title: "Mizinduo ya Biashara",
                    lead: "Kwa wajasiriamali wanaoanza: chapa, tovuti ya masoko na bidhaa inayofanya kazi — kwa mpangilio unaokuwezesha kuzindua kwa ujanja na kujifunza haraka.",
                    deliverables: ["Chapa na kurasa za kutia", "Programu za MVP", "Mifumo ya uhifadhi na biashara", "Usanidi wa takwimu na SEO", "Vifaa vya onyesho kwa wawekezaji", "Mzunguko wa uboreshaji"],
                    serviceKey: "startup",
                },
                {
                    id: "campaigns",
                    num: "04",
                    flag: "Kiraia na kisiasa",
                    title: "Majukwaa ya Kampeni",
                    lead: "Zana za kidijitali za kushinda kwa wagombea — MCA hadi gavana, na Rais inapohitajika. Za kushawishi, za haraka, na zilizojengwa kustahimili msongamano wa siku ya uchaguzi.",
                    deliverables: ["Tovuti za ilani", "Mifereji ya michango na bidhaa", "CRM ya wajitoleaji", "Ramani za majimbo", "Uunganishaji wa SMS na WhatsApp", "Msaada wa haraka wa chumba cha operesheni"],
                    serviceKey: "political-campaign",
                },
            ],
        },
        portfolio: {
            eyebrow: "Kazi teule",
            h1: "Ushahidi, si ahadi.",
            intro: "Onyesho la kazi tulizozindua katika afya, elimu, biashara na kampeni za kiraia. Majina ya wateja yamefupishwa pale inapohitajika ulinzi.",
            filters: [
                { key: "all", label: "Kazi zote" },
                { key: "health", label: "Mifumo ya afya" },
                { key: "institution", label: "Shule na vyuo vikuu" },
                { key: "startup", label: "Biashara mpya" },
                { key: "campaign", label: "Kampeni" },
            ],
            categoryLabels: { health: "Mfumo wa afya", institution: "Elimu", startup: "Biashara mpya", campaign: "Kampeni" },
            ctaH2: "Mradi wako unaweza kuwa unaofuata.",
            ctaCopy: "Mfumo wa afya, shule, biashara au kampeni — tungependa kusikia kutoka kwako.",
            ctaButton: "Anza mradi",
        },
        about: {
            eyebrow: "Studio yetu",
            h1a: "Tumejengwa mahali",
            h1b: "haja ni kubwa.",
            p1: "Hallomedics ilianza na uchunguzi rahisi: taasisi zinazoshikilia jamii pamoja — hospitali zake, shule zake, biashara zake mpya, uchaguzi wake — hudumiwa na programu mbovu zaidi.",
            p2: "Tulianza Nairobi tukijenga tovuti kwa mifumo ya afya barani Afrika Mashariki. Leo tunasambaza ulimwenguni kote, lakini lengo halijabadilika: miundombinu ya kidijitali tulivu na ya kuaminika kwa watu ambao wengine wote wanawategemea.",
            p3: "Njiani tukaongeza huduma nyingine tatu — majukwaa ya shule na vyuo vikuu, mizinduo ya biashara mpya, na mashine ya kampeni kwa wagombea kutoka gavana hadi rais — kwa sababu nidhamu iyoiyo husafiri vyema.",
            imgChip: "Kampala · utekelezaji wa e-elimu",
            valuesEyebrow: "Kanuni zetu za kazi",
            valuesH2: "Jinsi tunavyoamua, panapohitajika.",
            values: [
                { title: "Usahihi wa kliniki", copy: "Tunapanga kama wahandisi wa upasuaji: chunguza kwanza, kata mara moja. Hakuna vipengele vya ziada, hakuna uzinduzi wa kubahatisha." },
                { title: "Kienyeji kwanza, kiwango cha kimataifa", copy: "Imejengwa kwa hali halisi ya Afrika Mashariki — mtandao usio imara, pesa za simu, mtiririko wa kaunti — kwa kiwango cha uhandisi cha kimataifa." },
                { title: "Uaminifu mkubwa", copy: "Mifumo inayobaki hai siku ya udahili na usiku wa uchaguzi. Tunafuatilia, tunarekebisha na tunajibu simu." },
                { title: "Busara na uaminifu", copy: "Data za wagonjwa na mikakati ya kisiasa hushughulikiwa kwa usiri mkubwa na uangalizi wa data ulio wazi." },
            ],
            teamEyebrow: "Uongozi",
            teamH2: "Timu ndogo, kwa makusudi.",
            teamRoles: ["Mkakati na Mifumo ya Afya", "Kiongozi wa Uhandisi", "Ubunifu na Uhariri", "Utekelezaji na Msaada"],
            cta: "Fanya kazi nasi",
        },
        contact: {
            eyebrow: "Anza mradi",
            h1a: "Tuambie nini",
            h1b: "kinapaswa kufanya kazi.",
            name: "Jina kamili *",
            namePh: "Dkt. Jane Wanjiru",
            email: "Barua pepe *",
            emailPh: "jane@hospital.or.ke",
            org: "Shirika",
            orgPh: "Hospitali, shule, kampuni au kampeni",
            service: "Unahitaji nini? *",
            servicePh: "Chagua huduma",
            message: "Mradi wako *",
            messagePh: "Unajenga nini, ni kwa ajili ya nani, na lini unahitaji iwe hai?",
            submit: "Tuma swali",
            sending: "Inatuma…",
            successToast: "Swali limepokelewa — tunajibu ndani ya saa 24.",
            errorToast: "Imeshindikana kutuma swali lako. Tafadhali jaribu tena.",
            nextEyebrow: "Kinachofuata",
            steps: [
                { title: "Tunajibu ndani ya saa 24", copy: "Mtu halisi kutoka studio yetu ya Nairobi — kwa maswali, si hotuba ya mauzo." },
                { title: "Simu ya dakika 30 ya kugundua", copy: "Tunapanga malengo, vikwazo na ratiba yako. Bure, bila wajibu." },
                { title: "Mpango kamili ndani ya wiki moja", copy: "Wigo thabiti, bei ya uaminifu, hatua wazi. Kisha tunajenga." },
            ],
            office: "Westlands, Nairobi — tunahudumia Afrika Mashariki na ulimwenguni",
            hours: "Jumatatu–Ijumaa, 08:00–18:00 EAT",
        },
        serviceLabels: {
            "health-system": "Mfumo wa afya",
            institution: "Shule / chuo kikuu",
            startup: "Biashara mpya",
            "political-campaign": "Kampeni ya kisiasa",
            other: "Jambo jingine",
        },
        campaigns: {
            eyebrow: "Huduma 04 — Kiraia na kisiasa",
            h1a: "Shinda vita vya",
            h1b: "kidijitali mashinani.",
            sub: "Tovuti za ilani, mifereji ya michango na mashine ya wajitoleaji kwa wagombea — kutoka MCA hadi gavana, na Rais inapohitajika. Imejengwa Nairobi, imejaribiwa kwenye kampeni barani Afrika Mashariki.",
            ctaPrimary: "Panga kampeni yangu",
            ctaSecondary: "Tazama kazi za kampeni",
            imgChip: "Sauti Yetu 2027 — mradi maarufu wa kampeni",
            stats: ["wajitoleaji wameandikishwa", "majimbo yamefikiwa", "zimekusanywa mtandaoni"],
            funnelEyebrow: "Mifereji ya michango",
            funnelH2: "Michango ya M-Pesa, ukiwa hai.",
            funnelCopy: "Wafuasi huchangia kwa mibofyo mitatu — bila kadi, bila msukosuko. Kila shilingi inapata risiti, inakaguliwa na iko tayari kwa ripoti yako ya uzingatiaji. Jaribu onyesho la moja kwa moja.",
            step1: "Chagua kiasi",
            stepContinue: "Endelea",
            step2Title: "Angalia simu yako",
            step2Copy: "Weka PIN yako ya M-Pesa kwenye ombi tulilotuma kwa 07•• ••• •42.",
            step3Title: "Asante sana!",
            step3Copy: "mchango umehakikishwa. Kila shilingi inapata risiti na inakaguliwa.",
            receipt: "Risiti",
            donateAgain: "Endesha onyesho tena",
            demoNote: "Onyesho la majaribio — hakuna malipo halisi yanayochakatwa.",
            volEyebrow: "Zana za wajitoleaji",
            volH2: "Operesheni ya mashinani kila mfukoni.",
            volCopy: "Uandikishaji, uhakiki na upelekaji — pamoja na ramani za majimbo na uhamasishaji wa SMS/WhatsApp. Tazama jinsi mfupasi anavyojiunga:",
            volNamePh: "Jina lako",
            volWardPh: "Wadi / jimbo lako",
            volButton: "Jiunge na harakati",
            volSuccess: "Karibu kwenye timu!",
            volSuccessCopy: "Wewe ni mjitoleaji namba",
            volNote: "Mfano — hakuna kinachohifadhiwa.",
            tools: [
                { title: "Uandikishaji & uhakiki", copy: "Fomu za kupangilia za uandikishaji zenye mtiririko wa uhakiki wa kiwango cha wadi." },
                { title: "Ramani za majimbo", copy: "Ramani ya moja kwa moja ya wajitoleaji, mawakala na uwazi wa vituo vya kupigia kura." },
                { title: "Ujumbe wa SMS & WhatsApp", copy: "Ujumbe wa uhamasishaji uliogawanywa unaosomwa kweli kweli." },
                { title: "Ripoti za mashinani", copy: "Mawalawakala hutuma ripoti kutoka mashinani kwa wakati halisi." },
            ],
            featuresEyebrow: "Imejengwa kwa kampeni",
            featuresH2: "Mashine kubwa kwa mbio kubwa.",
            features: [
                { title: "Tovuti ya ilani", copy: "Jukwaa lako, likisimuliwa kwa uzuri — na kwa haraka hata kwenye Android rahisi zaidi." },
                { title: "Dashibodi ya chumba cha operesheni", copy: "Michango, wajitoleaji na hisia, moja kwa moja katika muonekano mmoja." },
                { title: "Uwezo wa siku ya uchaguzi", copy: "Miundombinu inayostahimili nchi nzima inapotazama." },
                { title: "Usiri na usalama", copy: "Mkakati hubaki wa siri. Ufikiaji ni wa majukumu na hukaguliwa." },
            ],
            trustNote: "Tunafanya kazi katika wigo wote wa kisiasa. Utambulisho wa wateja na mikakati hubaki siri — takwimu zilizoonyeshwa ni za kampeni za mfano.",
            ctaH2: "Zindua makao makuu ya kidijitali ya kampeni yako.",
            ctaCopy: "Mazungumzo moja yatosha kujua kampeni yako inahitaji nini.",
            ctaButton: "Panga kampeni yangu",
        },
        footer: {
            blurb: "Miundombinu ya kidijitali kwa mifumo ya afya, shule na vyuo vikuu, biashara mpya na kampeni za kiraia — imejengwa Afrika Mashariki, inatumika ulimwenguni kote.",
            cities: "Nairobi · Kampala · Dar es Salaam · Kigali",
            practice: "Huduma",
            studio: "Studio",
            contactTitle: "Mawasiliano",
            links: {
                health: "Mifumo ya afya",
                institutions: "Shule na vyuo vikuu",
                startups: "Biashara mpya",
                campaigns: "Kampeni za kisiasa",
                about: "Kuhusu",
                work: "Kazi",
                contact: "Wasiliana",
                admin: "Admin inbox",
            },
            hours: "Jumatatu–Ijumaa, 08:00–18:00 EAT",
            rights: "Haki zote zimehifadhiwa.",
            motto: "Huduma. Msimbo. Nchi.",
        },
    },
};
